export default __webpack_public_path__ + "static/media/warningOrange.d1856e3f.svg";